export const i18nAsset = {
    'de-DE': {
    },
    'en-EN': {
    },
    'fr-FR': {
    },
    'it-IT': {
    }
};
